import throttle from 'lodash.throttle';
import { CLASSES } from '../_consts';

export default function searchPopupInit() {
  const { isActive } = CLASSES;
  const fieldSel = '.js-main-field';
  const popupSel = '.search-popup';

  const searchBoxes = document.querySelectorAll(`${fieldSel} input`);

  function onOutsitePopupClick(e) {
    if (!e.target.closest(popupSel) && !e.target.closest(fieldSel)) {
      const popups = document.querySelectorAll(popupSel);
      popups.forEach((popup) => {
        popup.classList.remove(isActive);
      })
    }
  }
  document.addEventListener('click', onOutsitePopupClick);

  function createSearchPopupHTML(container, data, searchValue) {
    if (!container) return;

    const searchResult = data.results && data.results.reduce((str, item) => {
      const title = item.title &&
        item.title.replace(new RegExp(`${searchValue}`, 'gi'), `<span>$&</span>`);
      const newStr = `${str  }<li><a href="${item.url}">${title}</a></li>`;
      return newStr;
    }, '');

    const popularItems = data.populars && data.populars.reduce((str, item) => {
      const newStr = `${str  }
        <li>
          <a href="${item.url}">
            <img src="${item.img}" alt="" />
            <span>
              <span class="search-popup__item-title">${item.title}</span>
              ${
                item.discountPrice ?
                `<span class="search-popup__price search-popup__price--discount">
                  <b>${item.discountPrice}</b> <span>${item.price}</span>
                </span>` :
                `<span class="search-popup__price">
                  <b>${item.price}</b>
                </span>`
              }
            </span>
          </a>
        </li>`;
      return newStr;
    }, '');

    const categoriesItems = data.categories && data.categories.reduce((str, item) => {
      const newStr = `${str  }<li><a href="${item.url}">${item.title}</a></li>`;
      return newStr;
    }, '');

    /* eslint-disable no-param-reassign */
    container.innerHTML = `
      ${searchResult ? `<ul class="search-popup__results">
        ${searchResult}
      </ul><hr class="search-popup__hr" />` :
      ''}
      ${popularItems ? `<div class="search-popup__title">${data.popularTitle}</div>
      <ul class="search-popup__popular">
        ${popularItems}
      </ul>
      <hr class="search-popup__hr" />` :
      ''}
      ${categoriesItems ? `<div class="search-popup__title">${data.categoriesTitle}</div>
        <ul class="search-popup__categories">
          ${categoriesItems}
        </ul>
        <hr class="search-popup__hr" />` :
      ''}
      <a class="search-popup__all" href="${data.allSearchResults.url}">
        ${data.allSearchResults.title} (${data.allSearchResults.length})
      </a>
    `;
    /* eslint-enable no-param-reassign */
  }

  searchBoxes.forEach(box => {
    const popup = box.parentElement.parentElement.parentElement.querySelector('.search-popup');

    box.addEventListener('click', e => {
      if (popup && e.target.value.length > 0 && !$(popup).is(':empty')) {
        popup.classList.add(isActive);
      }
    });

    function sendRequest(target, lang = 'UA') {
      $.ajax({
        type: 'GET',
        dataType: 'json',
        url: '/searchResponse.php',
        // url: '/fakeResponse.json',
        data: JSON.stringify({
          value: target.value,
          lang,
        }),
        headers: {
          'Content-Type': 'application/json'
        },
        // xhrFields: {
        //   withCredentials: false
        // },
        success(response) {
          let newResponse = response;
          if (typeof response === 'string') {
            newResponse = JSON.parse(response);
          }
          if (Array.isArray(newResponse) && newResponse.length === 0) {
            popup.innerHTML = '';
            popup.classList.remove(isActive);
          } else {
            createSearchPopupHTML(popup, newResponse, target.value);
          }
        },
        complete() {
          if (target.value.length > 0 && !$(popup).is(':empty')) {
            popup.classList.add(isActive)
          };
        },
      });
    }
    const throttledSendRequest = throttle(sendRequest, 1000);

    box.addEventListener('input', e => {
      if (popup) {
        if (e.target.value.length > 0) {
          throttledSendRequest(e.target, e.target.nextElementSibling.value);
        } else {
          popup.classList.remove(isActive);
        }
      }
    });
  });
}